import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "default-table-area style-two recent-leads" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table align-middle" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "ms-2" }
const _hoisted_8 = { class: "fw-medium fs-14" }
const _hoisted_9 = { class: "d-flex align-items-center gap-1" }
const _hoisted_10 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_11 = { class: "material-symbols-outlined fs-16 text-primary" }
const _hoisted_12 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_13 = { class: "material-symbols-outlined fs-16 text-body" }
const _hoisted_14 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_15 = { class: "material-symbols-outlined fs-16 text-danger" }
const _hoisted_16 = { class: "d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2 showing-wrap p-4" }
const _hoisted_17 = { class: "fs-12 fw-medium" }
const _hoisted_18 = { "aria-label": "Page navigation example" }
const _hoisted_19 = { class: "pagination mb-0 justify-content-center" }
const _hoisted_20 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"d-flex justify-content-between align-items-center flex-wrap gap-3 p-4\"><h3 class=\"mb-0\">Recent Leads</h3><select class=\"form-select month-select form-control p-0 h-auto border-0 w-90\" style=\"background-position:right 0 center;\" aria-label=\"Default select example\"><option selected>This Week</option><option value=\"1\">This Month</option><option value=\"2\">This Year</option></select></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { scope: "col" }, [
                  _createElementVNode("div", { class: "form-check" }, [
                    _createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      value: "",
                      id: "flexCheckDefault"
                    })
                  ])
                ]),
                _createElementVNode("th", { scope: "col" }, "Customer"),
                _createElementVNode("th", { scope: "col" }, "Email"),
                _createElementVNode("th", { scope: "col" }, "Source"),
                _createElementVNode("th", { scope: "col" }, "Status"),
                _createElementVNode("th", { scope: "col" }, "Action")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedItems, (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.id
                }, [
                  _cache[2] || (_cache[2] = _createElementVNode("td", null, [
                    _createElementVNode("div", { class: "form-check" }, [
                      _createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        value: "",
                        id: "flexCheckDefault2"
                      })
                    ])
                  ], -1)),
                  _createElementVNode("td", null, [
                    _createVNode(_component_RouterLink, {
                      to: "/my-profile",
                      class: "d-flex align-items-center"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: item.customer.image,
                          class: "wh-44 rounded-circle",
                          alt: "user"
                        }, null, 8, _hoisted_6),
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("h6", _hoisted_8, _toDisplayString(item.customer.name), 1)
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(item.email), 1),
                  _createElementVNode("td", null, _toDisplayString(item.source), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["badge bg-opacity-10 p-2 fs-12 fw-normal", _ctx.computeClass(item.status)])
                    }, _toDisplayString(item.status), 3)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("button", _hoisted_10, [
                        _createElementVNode("i", _hoisted_11, _toDisplayString(item.action.view), 1)
                      ]),
                      _createElementVNode("button", _hoisted_12, [
                        _createElementVNode("i", _hoisted_13, _toDisplayString(item.action.edit), 1)
                      ]),
                      _createElementVNode("button", _hoisted_14, [
                        _createElementVNode("i", _hoisted_15, _toDisplayString(item.action.delete), 1)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("span", _hoisted_17, " Showing " + _toDisplayString(_ctx.startItem + 1) + " to " + _toDisplayString(_ctx.endItem) + " of " + _toDisplayString(_ctx.paginatedItems.length) + " Results ", 1),
          _createElementVNode("nav", _hoisted_18, [
            _createElementVNode("ul", _hoisted_19, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === 1 }])
              }, [
                _createElementVNode("a", {
                  class: "page-link icon",
                  href: "#",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)), ["prevent"]))
                }, _cache[4] || (_cache[4] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_left", -1)
                ]))
              ], 2),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (page) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: page,
                  class: _normalizeClass(["page-item", { active: _ctx.currentPage === page }])
                }, [
                  _createElementVNode("a", {
                    class: "page-link",
                    href: "#",
                    onClick: _withModifiers(($event: any) => (_ctx.goToPage(page)), ["prevent"])
                  }, _toDisplayString(page), 9, _hoisted_20)
                ], 2))
              }), 128)),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === _ctx.totalPages }])
              }, [
                _createElementVNode("a", {
                  class: "page-link icon",
                  href: "#",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)), ["prevent"]))
                }, _cache[5] || (_cache[5] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_right", -1)
                ]))
              ], 2)
            ])
          ])
        ])
      ])
    ])
  ]))
}